import { Pipe, PipeTransform } from '@angular/core';

import { CustomTranslationsService } from '../translations';
import { NO_VALUE } from '@pipes';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'translateVentilationReason',
})
export class TranslateVentilationReasonPipe implements PipeTransform {
  constructor(
    private customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  transform(value: string): string {
    if (!value) {
      return NO_VALUE;
    }
    const result =
      this.customTranslationsService.VENTILATION_REASONS_FOR_TRANSLATION[value] ?? value;

    return this.translateService.instant(result) ?? value;
  }
}
